import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import clsx from "clsx";

import CloseIcon from "../../icons/close-icon";
import SearchIcon from "../../icons/search-icon";
import {
  changeState,
  storeSearchResults,
  changeLoading,
  storeSearchVal,
} from "../../../services/state/search";
import { searchRequest } from "../../Archive/data";
import { errorNotify } from "../../notify/toastify";

const SearchBox = () => {
  const [searchInput, setSearchInput] = useState("");
  const [searchResults, setSearchResults] = useState([]);
  const searchResultsState = useSelector((state) => state.search.active);
  const dispatch = useDispatch();

  const searchHandler = (event) => {
    const value = event.target.value;
    setSearchInput(value);

    if (value === "") {
      dispatch(changeState(false));
      dispatch(storeSearchVal(""));
    }
  };

  const closeSearchHandler = () => {
    setSearchInput("");

    dispatch(changeState(false));
    dispatch(storeSearchVal(""));
  };

  const searchApiHandler = async () => {
    dispatch(changeLoading(true));

    try {
      const data = await searchRequest(searchInput);
      setSearchResults(data);
    } catch (error) {
      console.log(error);
    }

    dispatch(changeLoading(false));
  };

  const keyPressHandle = (event) => {
    if (event.key === "Enter" && searchInput.length >= 1) {
      searchApiHandler();
      dispatch(changeState(true));
      dispatch(storeSearchVal(searchInput));
    }
  };

  const goSearchHandler = () => {
    if (searchInput.length >= 1) {
      searchApiHandler();
      dispatch(changeState(true));
      dispatch(storeSearchVal(searchInput));
    }
  };

  useEffect(() => {
    dispatch(storeSearchResults(searchResults));
  }, [searchResults]);

  return (
    <div
      className={clsx(
        "search-box",
        searchResultsState && "change-searchbox-width"
      )}
    >
      <div className="search-box-right">
        <SearchIcon width={19} height={19} color="#838383" />
        <input
          type="text"
          value={searchInput}
          placeholder="متن مورد نظر خود را جست‌و‌جو کنید ..."
          onChange={searchHandler}
          onKeyDown={keyPressHandle}
        />
      </div>
      {/* {searchInput !== "" && (
        <div className='search-box-middle' onClick={goSearchHandler}>
          <span>برو</span>
        </div>
      )} */}
      {searchInput !== "" && (
        <div className="search-box-left" onClick={closeSearchHandler}>
          <CloseIcon width={11} height={11} color="#303030" />
        </div>
      )}
    </div>
  );
};

export default SearchBox;
